import React from "react";
import history from '../../../history'

class CustomiseHeader extends React.Component{
  /* istanbul ignore next */
  customizedBack = () => {
    const previousUrl = document.referrer;
    if (previousUrl.includes("package") && 
      !previousUrl.includes("mortgageFinance") && 
      !previousUrl.includes("investors") && 
      !previousUrl.includes("trades")) {
      history.go(-3)
    } else {
      history.go(-1);
    }
  };

  render(){
    return(
      <div className="row no-margin">
        <div className="col-sm-12">
          <div className="row">
            <div className="back-btn" id="back-to-selection" onClick={this.customizedBack}> &lt; Back </div>
            <hr/>
          </div>
          <div className="row">
            <div className="section-no-pad-title text-center">Customise Your Subscription</div>
          </div>
        </div>
      </div>
    )
  }
}

export default CustomiseHeader
